"use strict";

module.exports = {
    "i-services": {
        "404": "404",
        "adresa": "Адреси",
        "advertising": "Реклама",
        "afisha": "Афіша",
        "all": "Усі сервіси",
        "api": "API",
        "appmetrica": "AppMetrica",
        "appsearch": "Програми",
        "audience": "Аудиторії",
        "auto": "Авто",
        "autoru": "Авто.ру",
        "avia": "Авіаквитки",
        "aziada": "Азіада",
        "ba": "Баян",
        "backapv": "Партнер Я.Карт",
        "balance": "Баланс",
        "bar": "Бар",
        "bar-ie": "Бар для ІЕ",
        "bar-ie9": "Бар для ІЕ9",
        "bayan": "Банери Яндекса",
        "blogs": "Блоги",
        "books": "Книжки",
        "browser": "Браузер",
        "calendar": "Календар",
        "captcha": "ой...",
        "catalogwdgt": "Каталог віджетів",
        "chrome": "Хром із пошуком Яндекса",
        "city": "Міста",
        "cityday": "День міста",
        "clickhouse": "ClickHouse",
        "collection": "Колекція",
        "company": "Компанія",
        "contest": "Contest",
        "delivery": "Доставка",
        "desktop": "Персональний пошук",
        "direct": "Директ",
        "direct.market": "Маркет",
        "disk": "Диск",
        "display": "Дисплей",
        "ege": "ЕГЭ",
        "expert": "Експерт",
        "feedback": "Зворотний зв'язок",
        "feedback2": "Зворотний зв'язок",
        "ff": "ФФ із пошуком Яндекса",
        "fotki": "Фотки",
        "fresh": "Свіже",
        "games": "Іграшки",
        "geocontext": "Геоконтекст",
        "goroda": "Міста",
        "help": "Допомога",
        "i": "Мої сервіси",
        "ie": "ІЕ із пошуком Яндекса",
        "images": "Зображення",
        "images-com": "Зображення",
        "interests": "Інтереси",
        "internet": "Інтернет",
        "kassa": "Каса",
        "keyboard": "Клавіатура",
        "kraski": "Фарби",
        "kuda": "Куди всі йдуть",
        "large": "Яндекс для тих, хто погано бачить",
        "legal": "Правові документи",
        "lenta": "Стрічка",
        "libra": "Бібліотека",
        "literacy": "Тиждень боротьби за грамотність",
        "local": "Локальна мережа",
        "lost": "Незабудки",
        "love": "День взаємного тяжіння — 13 серпня",
        "mail": "Пошта",
        "maps": "Карти",
        "maps-wiki": "Народна карта",
        "market": "Маркет",
        "market.advertising": "Маркет",
        "master": "Майстер",
        "metrika": "Метрика",
        "metro": "Метро",
        "mobile": "Мобільний",
        "moikrug": "Мой Круг",
        "money": "Деньги",
        "museums": "Дні історичної та культурної спадщини",
        "music": "Музика",
        "music-partner": "Музика: статистика",
        "nahodki": "Мої знахідки",
        "nano": "Нано",
        "newhire": "Наніматор",
        "news": "Новини",
        "notifications": "Нотифікаційна панель",
        "oauth": "Авторизація",
        "online": "Онлайн",
        "openid": "OpenID",
        "opera": "Opera Software",
        "opinion": "Цитати",
        "partners": "Рекламна мережа",
        "partnersearch": "Пошук для партнерів",
        "passport": "Паспорт",
        "pdd": "Пошта для доменy",
        "peoplesearch": "Люди",
        "perevod": "Перекладач",
        "probki": "Затори",
        "pulse": "блоги: пульс",
        "punto": "Punto switcher",
        "pvo": "Відповіді",
        "rabota": "Робота",
        "radar": "Радар",
        "ramazan": "",
        "rasp": "Розклади",
        "realty": "Нерухомість",
        "referats": "Реферати",
        "rk": "Є запитання?",
        "root": "Яндекс.Олімпіада для Unix-адміністраторів",
        "school": "Школа",
        "search": "Пошук",
        "server": "Сервер",
        "shtrafi": "Штрафи",
        "site": "Пошук для сайту",
        "slovari": "Словники",
        "so": "Самооборона",
        "social": "Соціалізм",
        "soft": "Програми",
        "sport": "Спорт",
        "sprav": "Довідник",
        "start": "Стартова сторінка",
        "stat": "Статистика",
        "subs": "Підписки",
        "taxi": "Таксі",
        "telephony": "Телефония",
        "terms": "Розмовник",
        "tests": "Тести й опитування",
        "tickets": "Квитки",
        "time": "Яндекс.Час",
        "toloka": "Яндекс.Толока",
        "toster": "Тости",
        "translate": "Перекладач",
        "tune": "Налаштування",
        "tv": "ТБ",
        "uslugi": "Послуги",
        "video": "Відео",
        "video-com": "Відео",
        "vno": "ЗНО",
        "wdgt": "Віджети",
        "weather": "Погода",
        "webmaster": "Вебмайстер",
        "webmaster-api": "API Вебмайстра",
        "widgets": "Віджети",
        "wordstat": "Статистика",
        "wow": "Я.ру",
        "www": "Пошук",
        "xmlsearch": "XML",
        "yaca": "Каталог",
        "yamb": "Медійні банери",
        "zakladki": "Закладки"
    }
};